import { Injectable } from '@angular/core';
import { Aplicacao } from 'app/shared/models/aplicacao/aplicacao';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppStoreService {
  private aplicacao$ = new BehaviorSubject<Aplicacao>(null);

  constructor() {}

  setAplicacao(aplicacao: Aplicacao) {
    this.aplicacao$.next(aplicacao);
  }

  getAplicacao(): Observable<Aplicacao> {
    return this.aplicacao$.asObservable();
  }
}
